import React from 'react';
import { observer } from 'mobx-react';
import InterestRateCalculationTypesVM from '../InterestRateCalculationTypesVM';
import { InterestRateCalculationTypeEditComponent } from './InterestRateCalculationTypeEdit';
import { NeoGrid } from '@singularsystems/neo-react';
import { EnumHelper } from '@singularsystems/neo-core';
import { InterestCalculationType } from '../../../Models/Rates/InterestCalculationType.enum';

interface IInterestRateCalculationTypeListProps {
    viewModel: InterestRateCalculationTypesVM;
}

@observer
export default class InterestRateCalculationTypeList extends React.Component<IInterestRateCalculationTypeListProps> {

    constructor(props: IInterestRateCalculationTypeListProps) {
        super(props);
    }

    public render() {
        const viewModel = this.props.viewModel;

        if (viewModel.editingInterestRateCalculationType) {
            return <InterestRateCalculationTypeEditComponent viewModel={viewModel} interestRateCalculationType={viewModel.editingInterestRateCalculationType} />
        } else {
            return this.renderInterestRateCalculationTypeList(viewModel);
        }
    }

    public renderInterestRateCalculationTypeList(viewModel: InterestRateCalculationTypesVM) {
        return (
            <NeoGrid.Grid items={viewModel.interestRateCalculationTypeList} addButton={{ onClick: () => viewModel.newInterestRateCalculationType() }}>
                {(item, meta) => (
                    <NeoGrid.Row>
                        <NeoGrid.Column display={meta.interestCalculationType} label="For Calculation Type" select={{ items: EnumHelper.asList(InterestCalculationType) }} />
                        <NeoGrid.Column display={meta.calculationName} />
                        <NeoGrid.Column display={meta.description} />
                        <NeoGrid.Column display={meta.formula} cellClassName="formula" />
                        <NeoGrid.Column display={meta.ordinal} />
                        <NeoGrid.ButtonColumn
                            editButton={{ onClick: () => viewModel.beginEditingInterestRateCalculationType(item) }}
                            deleteButton={{ onClick: () => viewModel.deleteInterestRateCalculationType(item.interestRateCalculationTypeId) }} />
                    </NeoGrid.Row>
                )}
            </NeoGrid.Grid>
        )
    }
}